import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { provideAppCheck, initializeAppCheck, ReCaptchaEnterpriseProvider, AppCheck } from '@angular/fire/app-check';
import { provideAuth, getAuth, connectAuthEmulator } from '@angular/fire/auth';
import { FirebaseEnvironmentModel } from '../model/firebase-environment.model';

export function provideFirebaseAndAuth(firebase: FirebaseEnvironmentModel) {
  return [
    provideFirebaseApp(() => initializeApp(firebase.config)),
    provideAppCheck((): AppCheck => {
      if (firebase.useFirebaseEmulator || !firebase.appCheckEnabled) {
        // In dev mode, AppCheck can be skipped
        return null as any as AppCheck;
      }
      return initializeAppCheck(getApp(), {
        provider: new ReCaptchaEnterpriseProvider(firebase.config.keyId),
        isTokenAutoRefreshEnabled: true,
      });
    }),
    provideAuth(() => {
      const auth = getAuth();
      if (firebase.useFirebaseEmulator) {
        connectAuthEmulator(auth, 'https://firebase.app.docker.movinmotion.net:9099', { disableWarnings: true });
      }
      return auth;
    }),
  ];
}
